import React from 'react';
import Alert from '../../Alert';
import { any, arrayOf, string, shape } from 'prop-types';

const ContactAlert = (props) => {
  if (!props.TemporaryInformation) return null;

  const { Comment, FromDate, ToDate } = props.TemporaryInformation;

  const showComments = () => {
    if (!FromDate && !ToDate) return true;

    const date = new Date().toISOString();
    if (!FromDate && ToDate > date) return true;
    if (FromDate < date && !ToDate) return true;
    if (FromDate < date && ToDate > date) return true;

    return false;
  };
  const showAlert = Comment.length > 0 && showComments();

  if (showAlert) {
    const comments = Comment.map((item, index) => <p key={index}>{item}</p>);
    return (
      <div className="contact-alert">
        <Alert type="warning">
          <div className="row">
            <div className="small-12 columns">
              <div className="c-alert--content contact-alert--content">
                {comments}
              </div>
            </div>
          </div>
        </Alert>
      </div>
    );
  }

  return null;
};

ContactAlert.propTypes = {
  TemporaryInformation: shape({
    Comment: arrayOf(string),
    FromDate: any,
    ToDate: any,
  }),
};

export default ContactAlert;
